document.addEventListener("DOMContentLoaded", function () {
  var eventHub = new Vue();

  //check if app4 exist
  var element = document.getElementById("locations-app-4");
  if (typeof element != "undefined" && element != null) {
    var app4 = new Vue({
      el: "#locations-app-4",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productsIds: [],
        variantsIds: [],
        inventories: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        _.each(document.querySelectorAll("[data-vv-id]"), (el) => {
          if (
            el.getAttribute("data-vv-id") != undefined &&
            el.getAttribute("data-vv-id") != ""
          ) {
            this.variantsIds.push(el.getAttribute("data-vv-id"));
          }
        });
        _.each(document.querySelectorAll("[data-vp-id]"), (el) => {
          if (
            el.getAttribute("data-vp-id") != undefined &&
            el.getAttribute("data-vp-id") != ""
          ) {
            this.productsIds.push(el.getAttribute("data-vp-id"));
          }
        });
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductsInventories();
          window.setZapietLocation(value.id);
        });

        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
        });
      },
      methods: {
        getProductsInventories() {
          if (this.productsIds.length > 0) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productsIds.join(","),
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
      },
    });
  }

  //check if app3 exist
  var element = document.getElementById("locations-app-3");
  if (typeof element != "undefined" && element != null) {
    var app3 = new Vue({
      el: "#locations-app-3",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productId: null,
        variantId: null,
        inventories: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        let el = document.getElementById("locations-app-3");

        if (
          el.getAttribute("data-vv-id") != undefined &&
          el.getAttribute("data-vv-id") != ""
        ) {
          this.productId = el.getAttribute("data-vp-id");
          this.variantId = el.getAttribute("data-vv-id");
        }
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductInventory();
        });
        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
          this.checkAddToCartDiv();
        });
      },
      computed: {
        stockForVariant() {
          return this.findStockQtyForVariant(this.variantId);
        },
        stockShouldBeReported() {
          let variant = this.findVariant(this.variantId);

          return variant && variant.track_inventory ? true : false;
        },
      },
      methods: {
        checkAddToCartDiv() {
          let addToCartDiv = document.getElementById("add-to-cart-pdp");
          if (this.ship_direct) {
            addToCartDiv.classList.remove("tw-hidden!");
          } else if (
            !this.ship_direct &&
            this.findStockQtyForVariant(this.variantId) <= 0
          ) {
            addToCartDiv.classList.add("tw-hidden!");
          } else if (
            !this.ship_direct &&
            this.findStockQtyForVariant(this.variantId) > 0
          ) {
            addToCartDiv.classList.remove("tw-hidden!");
          }
        },
        getProductInventory() {
          if (this.productId) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productId,
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                  this.checkAddToCartDiv();
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = this.findVariant(variant_id);

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
        findVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );
            return variant ? variant : undefined;
          } else {
            return undefined;
          }
        },
        enableShipDirect() {
          this.ship_direct = !this.ship_direct;
          localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
          eventHub.$emit("shipDirectChange", this.ship_direct);
        },
      },
    });
  }

  //check if app2 exist
  var element = document.getElementById("locations-app-2");
  if (typeof element != "undefined" && element != null) {
    var app2 = new Vue({
      el: "#locations-app-2",
      delimiters: ["${", "}"],
      data: {
        selectedLocation: null,
        productsIds: [],
        variantsIds: [],
        inventories: [],
        variantsInCart: [],
        loading: false,
        ship_direct: false,
      },
      created() {
        _.each(document.querySelectorAll("[data-vv-id]"), (el) => {
          if (
            el.getAttribute("data-vv-id") != undefined &&
            el.getAttribute("data-vv-id") != ""
          ) {
            this.variantsIds.push(el.getAttribute("data-vv-id"));
          }
        });
        _.each(document.querySelectorAll("[data-vp-id]"), (el) => {
          if (
            el.getAttribute("data-vp-id") != undefined &&
            el.getAttribute("data-vp-id") != ""
          ) {
            this.productsIds.push(el.getAttribute("data-vp-id"));
          }
        });
        eventHub.$on("selectedLocationChange", (value) => {
          this.selectedLocation = value;
          this.getProductsInventories();
        });
        eventHub.$on("shipDirectChange", (value) => {
          this.ship_direct = value;
        });
      },
      methods: {
        getProductsInventories() {
          if (this.productsIds.length > 0) {
            this.loading = true;
            axios
              .get(
                "https://zurchersinventorysync.com:8443/api/products_by_location",
                {
                  params: {
                    location_id: this.selectedLocation.id,
                    product_ids: this.productsIds.join(","),
                  },
                  headers: {
                    "Api-Token":
                      "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
                  },
                }
              )
              .then((response) => {
                if (response.data.success) {
                  this.inventories = response.data.data;
                  this.loading = false;
                }
              })
              .catch(function (error) {
                console.error(error);
                eventHub.$emit("shipDirectChange", true);
              });
          }
        },
        findStockQtyForVariant(variant_id) {
          if (variant_id != undefined) {
            let variant = _.first(
              _.filter(this.inventories, (inventory) => {
                return inventory.variant_id == variant_id;
              })
            );

            return variant ? (variant.qty ? variant.qty : 0) : 0;
          } else {
            return 0;
          }
        },
        addToCart(variant_id, e) {
          if (this.variantIsInCart(variant_id)) {
            this.redirect("/cart");
          } else {
            let target = e.currentTarget;
            let addText = target.querySelector(".add-text");
            let faSpinner = target.querySelector(".fa-spinner");
            let addedText = target.querySelector(".added-text");
            target.classList.toggle("in-cart");
            addText.classList.toggle("tw-hidden!");
            faSpinner.classList.toggle("tw-hidden!");

            axios
              .post("/cart/add.js", {
                id: variant_id,
                quantity: 1,
              })
              .then((response) => {
                this.variantsInCart.push(variant_id);
                faSpinner.classList.toggle("tw-hidden!");
                addedText.classList.toggle("tw-hidden!");
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        },
        redirect(url) {
          window.location.href = url;
        },
        variantIsInCart(variant_id) {
          return _.includes(this.variantsInCart, variant_id);
        },
      },
    });
  }

  var app1 = new Vue({
    el: "#locations-app-1",
    delimiters: ["${", "}"],
    data: {
      showLocationInfo: false,
      showLocationSelector: false,
      locations: [],
      selectedLocation: null,
      searchKey: "",
      ship_direct: false,
      schedules: { ...window.schedules },
      now: moment(),
    },
    created() {
      moment.tz.setDefault("America/Denver");
      this.locations = [
        {
          id: 36734697534,
          name: "Zurchers American Fork",
          address1: "177 North West State Road",
          address2: "",
          city: "American Fork",
          zip: "84003",
          province: "UT",
          country: "US",
          phone: "+18016420173",
          created_at: "2020-06-15T14:32:41-06:00",
          updated_at: "2020-06-15T14:32:42-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36734697534",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 36758978622,
          name: "Zurchers Boise",
          address1: "1157 North Milwaukee Street",
          address2: "",
          city: "Boise",
          zip: "83704",
          province: "Idaho",
          country: "US",
          phone: "+12083750850",
          created_at: "2020-06-22T09:19:11-06:00",
          updated_at: "2022-06-13T12:30:44-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "ID",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36758978622",
          localized_country_name: "United States",
          localized_province_name: "Idaho",
        },
        {
          id: 36759011390,
          name: "Zurchers Brickyard",
          address1: "1172 Brickyard RD. Ste 45",
          address2: "",
          city: "SLC",
          zip: "84106",
          province: "UT",
          country: "US",
          phone: "+18014857777",
          created_at: "2020-06-22T09:25:08-06:00",
          updated_at: "2020-06-22T09:25:08-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36759011390",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 36759044158,
          name: "Zurchers Cottonwood Heights",
          address1: "1378 East Park Centre Dr.",
          address2: "",
          city: "Cottonwood Heights",
          zip: "84121",
          province: "UT",
          country: "US",
          phone: "+18012552300",
          created_at: "2020-06-22T09:26:00-06:00",
          updated_at: "2020-06-22T09:26:00-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36759044158",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 19746183,
          name: "Zurchers Draper",
          address1: "11479 S. State Street",
          address2: "Unit A",
          city: "Draper",
          zip: "84020",
          province: "Utah",
          country: "US",
          phone: "+18012519100",
          created_at: "2016-12-14T21:38:36-07:00",
          updated_at: "2022-07-07T12:51:12-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/19746183",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 60904702014,
          name: "Zurchers Idaho Falls",
          address1: "1624 East 17th Street",
          address2: "",
          city: "Idaho Falls",
          zip: "83404",
          province: "Idaho",
          country: "US",
          phone: "+12085233100",
          created_at: "2021-04-23T07:45:04-06:00",
          updated_at: "2022-07-07T12:57:33-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "ID",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904702014",
          localized_country_name: "United States",
          localized_province_name: "Idaho",
        },
        {
          id: 60904734782,
          name: "Zurchers Jordan Landing",
          address1: "7047 Plaza Center Drive",
          address2: "",
          city: "West Jordan",
          zip: "84084",
          province: "Utah",
          country: "US",
          phone: "+18012825879",
          created_at: "2021-04-23T07:45:46-06:00",
          updated_at: "2022-07-07T12:58:06-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904734782",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 36759076926,
          name: "Zurchers Logan",
          address1: "1475 N Main St. Ste 130",
          address2: "",
          city: "Logan",
          zip: "84341",
          province: "UT",
          country: "US",
          phone: "+14357530400",
          created_at: "2020-06-22T09:26:38-06:00",
          updated_at: "2021-04-24T17:53:06-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36759076926",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 60904767550,
          name: "Zurchers Meridian",
          address1: "1330 North Eagle Road",
          address2: "",
          city: "Meridian",
          zip: "83642",
          province: "Idaho",
          country: "US",
          phone: "",
          created_at: "2021-04-23T07:46:17-06:00",
          updated_at: "2021-04-23T07:46:17-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "ID",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904767550",
          localized_country_name: "United States",
          localized_province_name: "Idaho",
        },
        {
          id: 68782587966,
          name: "Zurchers Mesquite",
          address1: "1340 N Town E Blvd",
          address2: "Ste A",
          city: "Mesquite",
          zip: "75150",
          province: "Texas",
          country: "US",
          phone: "+14694093008",
          created_at: "2025-03-10T13:07:49-06:00",
          updated_at: "2025-04-28T10:59:38-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "TX",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/68782587966",
          localized_country_name: "United States",
          localized_province_name: "Texas",
        },
        {
          id: 60904800318,
          name: "Zurchers Nampa",
          address1: "1870 Caldwell Boulevard",
          address2: "",
          city: "Nampa",
          zip: "83651",
          province: "Idaho",
          country: "US",
          phone: "+12085460878",
          created_at: "2021-04-23T07:46:44-06:00",
          updated_at: "2022-07-07T12:58:41-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "ID",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904800318",
          localized_country_name: "United States",
          localized_province_name: "Idaho",
        },
        {
          id: 68782358590,
          name: "Zurchers Omaha",
          address1: "12979 West Center Road",
          address2: "",
          city: "Omaha",
          zip: "68144",
          province: "Nebraska",
          country: "US",
          phone: "+15313354110",
          created_at: "2025-03-10T12:54:32-06:00",
          updated_at: "2025-04-29T12:04:44-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "NE",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/68782358590",
          localized_country_name: "United States",
          localized_province_name: "Nebraska",
        },
        {
          id: 36759109694,
          name: "Zurchers Orem",
          address1: "340 East 800 South",
          address2: "",
          city: "Orem",
          zip: "84097",
          province: "UT",
          country: "US",
          phone: "+18017346400",
          created_at: "2020-06-22T09:27:13-06:00",
          updated_at: "2020-06-22T09:27:14-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36759109694",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 68782391358,
          name: "Zurchers Overland Park",
          address1: "8400 W 135th St",
          address2: "",
          city: "Overland Park",
          zip: "66223",
          province: "Kansas",
          country: "US",
          phone: "+19133534341",
          created_at: "2025-03-10T13:01:20-06:00",
          updated_at: "2025-04-29T14:55:52-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "KS",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/68782391358",
          localized_country_name: "United States",
          localized_province_name: "Kansas",
        },
        {
          id: 36759142462,
          name: "Zurchers Riverdale",
          address1: "4040 West Riverdale Rd.",
          address2: "",
          city: "Ogden",
          zip: "84405",
          province: "UT",
          country: "US",
          phone: "+18013349600",
          created_at: "2020-06-22T09:27:47-06:00",
          updated_at: "2020-06-22T09:27:47-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/36759142462",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 60904833086,
          name: "Zurchers Salt Lake City",
          address1: "389 West 1830 South",
          address2: "#100",
          city: "Salt Lake City",
          zip: "84115",
          province: "Utah",
          country: "US",
          phone: "+18014845000",
          created_at: "2021-04-23T07:47:18-06:00",
          updated_at: "2022-09-01T14:52:04-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904833086",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
        {
          id: 68782522430,
          name: "Zurchers Springfield",
          address1: "2620 S Campbell Ave",
          address2: "",
          city: "Springfield",
          zip: "65807",
          province: "Missouri",
          country: "US",
          phone: "+14172039939",
          created_at: "2025-03-10T13:06:41-06:00",
          updated_at: "2025-04-29T14:56:14-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "MO",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/68782522430",
          localized_country_name: "United States",
          localized_province_name: "Missouri",
        },
        {
          id: 60904865854,
          name: "Zurchers Twin Falls",
          address1: "1605 Blue Lakes Boulevard North",
          address2: "",
          city: "Twin Falls",
          zip: "83301",
          province: "Idaho",
          country: "US",
          phone: "+12087345800",
          created_at: "2021-04-23T07:48:00-06:00",
          updated_at: "2022-07-07T12:59:36-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "ID",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904865854",
          localized_country_name: "United States",
          localized_province_name: "Idaho",
        },
        {
          id: 60904898622,
          name: "Zurchers West Valley",
          address1: "3755 Constitution Boulevard",
          address2: "",
          city: "West Valley City",
          zip: "84119",
          province: "Utah",
          country: "US",
          phone: "+18019551070",
          created_at: "2021-04-23T07:48:37-06:00",
          updated_at: "2022-07-07T12:59:52-06:00",
          country_code: "US",
          country_name: "United States",
          province_code: "UT",
          legacy: false,
          active: true,
          admin_graphql_api_id: "gid://shopify/Location/60904898622",
          localized_country_name: "United States",
          localized_province_name: "Utah",
        },
      ];

      let newLocations = this.locations.filter((l) => l.id != 70633586750);
      this.locations = newLocations;
      this.selectedLocation = this.getDefaultLocation();
      eventHub.$emit("selectedLocationChange", this.selectedLocation);
      this.ship_direct = this.getDefaultShipDirectValue();
      eventHub.$emit("shipDirectChange", this.ship_direct);

      axios
        .get("https://zurchersinventorysync.com:8443/api/shopify_locations", {
          headers: {
            "Api-Token": "OIOq9LNpcq2VvujvPIiKl7Ckzrj1ZgV3W9bGOi84Z2Cib8mYWU",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.locations = response.data.locations;
            let newLocations = this.locations.filter(
              (l) => l.id != 70633586750
            );
            this.locations = newLocations;
            this.selectedLocation = this.getDefaultLocation();
            eventHub.$emit("selectedLocationChange", this.selectedLocation);
            this.ship_direct = this.getDefaultShipDirectValue();
            eventHub.$emit("shipDirectChange", this.ship_direct);
          }
        })
        .catch(function (error) {
          console.error(error);
          eventHub.$emit("shipDirectChange", true);
        });

      eventHub.$on("shipDirectChange", (value) => {
        this.ship_direct = value;
      });

      window.ZapietEvent.listen("selected_method", function (checkout_method) {
        if (checkout_method == "delivery" || checkout_method == "shipping") {
          this.ship_direct = true;
          eventHub.$emit("shipDirectChange", this.ship_direct);
        } else {
          this.ship_direct = false;
          eventHub.$emit("shipDirectChange", this.ship_direct);
        }
      });
    },
    computed: {
      filteredLocations() {
        return _.filter(this.locations, (location) => {
          return location.name
            .toLowerCase()
            .includes(this.searchKey.toLowerCase());
        });
      },
    },
    methods: {
      selectLocation(location) {
        this.selectedLocation = location;
        this.showLocationSelector = false;
        localStorage.setItem(
          "v-location-app-default-value",
          this.selectedLocation.id
        );
        eventHub.$emit("selectedLocationChange", this.selectedLocation);
        this.disableShipDirect();
      },
      getDefaultLocation() {
        let session = localStorage.getItem("v-location-app-default-value");
        session =
          session != null && session != undefined
            ? session
            : _.first(this.locations).id;
        return _.find(this.locations, (location) => {
          return location.id == session;
        });
      },
      getDefaultShipDirectValue() {
        let session = localStorage.getItem("v-location-app-ship_direct");
        session = session != null && session != undefined ? session : false;

        return session == "true" || session == true ? true : false;
      },
      enableShipDirect() {
        this.ship_direct = true;
        localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
        eventHub.$emit("shipDirectChange", this.ship_direct);
        this.showLocationInfo = false;
      },
      disableShipDirect() {
        this.ship_direct = false;
        localStorage.setItem("v-location-app-ship_direct", this.ship_direct);
        eventHub.$emit("shipDirectChange", this.ship_direct);
        this.showLocationInfo = false;
      },
      getScheduleLocation(location_id) {
        return _.find(this.schedules.schedules, (location) => {
          return location.locationId == location_id;
        });
      },
      getScheduleDay(schedule_location) {
        return _.find(schedule_location.open_dates, (date) => {
          return date.day_number == this.now.day();
        });
      },
      getScheduleHours(location) {
        let schedule_location = this.getScheduleLocation(location.id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          let from = moment(schedule_day.from, "hh:mm:ss");
          let to = moment(schedule_day.to, "hh:mm:ss");

          return from.format("h:mmA") + "-" + to.format("h:mmA");
        }

        let from = moment("09:00:00", "hh:mm:ss");
        let to = moment("18:00:00", "hh:mm:ss");

        return from.format("h:mmA") + "-" + to.format("h:mmA");
      },
      isWorkingDay(location_id) {
        if (!this.schedules.hasOwnProperty("schedules")) {
          return false;
        }

        if (this.schedules.hasOwnProperty("holidays")) {
          let isHolyDay = _.find(this.schedules.holidays, (day) => {
            return this.now.isSame(day, "day");
          });

          if (isHolyDay) {
            return false;
          }
        }

        let schedule_location = this.getScheduleLocation(location_id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          if (!schedule_day.open) {
            return false;
          }
        }

        return true;
      },
      isOpen(location_id) {
        if (!this.isWorkingDay(location_id)) {
          return false;
        }

        let schedule_location = this.getScheduleLocation(location_id);

        if (schedule_location) {
          let schedule_day = this.getScheduleDay(schedule_location);

          let beforeTime = moment(schedule_day.from, "hh:mm:ss");
          let afterTime = moment(schedule_day.to, "hh:mm:ss");

          if (this.now.isBetween(beforeTime, afterTime)) {
            return true;
          }
        }

        return false;
      },
      formatPhone(phone) {
        var cleaned = ("" + phone).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          // var intlCode = match[1] ? "+1 " : "";
          // return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
          return ["(", match[2], ") ", match[3], "-", match[4]].join("");
        }
        return phone;
      },
    },
  });
});
